import { SelectedMenu } from 'rangeConfig/@types';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { colorFilter } from 'rangeConfig/shared/filters/configFilters';
import deleteFrontLayout from 'rangeConfig/shared/behaviors/deleteFrontLayout';
import {
  matchDepth,
  matchHeight,
  matchType,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import { isProductType, isSelectedEntityDrawer } from 'rangeConfig/shared/rules/hideMenuRules';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import addFrontLayoutForSelectedFront from 'rangeConfig/shared/behaviors/addFrontLayoutForSelectedFront';
import { matchFrontLayoutToFrame } from 'rangeConfig/smastad/filters/selectedMenuProductFilters';
import dragAddToTarget from 'rangeConfig/shared/behaviors/dragAddToTarget';
import autoFillHandles from 'rangeConfig/shared/behaviors/autoFillHandles';
import removeHandleFromSelectedEntity from 'rangeConfig/shared/behaviors/removeHandleFromSelectedEntity';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import addAccessory from 'rangeConfig/smastad/behaviors/addAccessory';
import removeAccessoriesForSelectedEntity from 'rangeConfig/smastad/behaviors/removeAccessoriesForSelectedEntity';
import { getQPPImage } from 'products';
import showHandlesDrillTemplateSheet from 'rangeConfig/shared/behaviors/showHandlesDrillTemplateSheet';
import replaceDoor from 'rangeConfig/shared/behaviors/replaceDoor';

const getMenuTitle = (coreApi: CoreApi) => {
  if (isSelectedEntityDrawer(coreApi)) {
    return 'storageone.selectedProductListCustomiseDrawer';
  } else {
    return 'storageone.selectedProductListCustomiseDoor';
  }
};

const selectedMenu: SelectedMenu = {
  menuTitle: getMenuTitle,
  behaviors: {
    productDeleted: [deleteProduct],
    selectedMenuExited: [showHandlesDrillTemplateSheet]
  },
  content: [
    {
      id: 'fronts-selected-menu-front-layout',
      title: 'storageone.frontLayoutTabTitle',
      cardsTitle: 'name',
      productThumbToolTip: 'name',
      cardsSubtitle: '',
      behaviors: {
        productDropped: [showDoors, addFrontLayoutForSelectedFront],
        productClicked: [showDoors, addFrontLayoutForSelectedFront]
      },
      productTypes: [ProductType.SMASTAD_FRONT_LAYOUT],
      productFilters: [matchFrontLayoutToFrame],
      hideInfoButton: true,
      hidePrice: true,
      alternativeSelectedProductList: true,
      noneOption: {
        behaviors: { removeProducts: [deleteFrontLayout] },
        selected: () => false,
        title: 'storageone.productListNoDoorsOptionTitle'
      }
    },
    {
      id: 'fronts-selected-menu-fronts',
      title: 'storageone.frontStyleTabTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'designText',
      productCardMainImage: getQPPImage,
      behaviors: { productClicked: [replaceDoor], productDropped: [addProduct] },
      filters: [colorFilter],
      productFilters: [matchWidth, matchHeight, matchDepth, matchType]
    },
    {
      id: 'fronts-selected-menu-handles',
      title: 'storageone.productListHandlesTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'designText, communicatedSizeText',
      productThumbToolTip: 'name, designText',
      behaviors: {
        productDropped: [showDoors, dragAddToTarget],
        productClicked: [showDoors, autoFillHandles]
      },
      productTypes: [ProductType.HANDLE, ProductType.KNOB, ProductType.EDGE_HANDLE],
      filters: [],
      productFilters: [],
      noneOption: {
        behaviors: { removeProducts: [removeHandleFromSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([
          ProductType.HANDLE,
          ProductType.KNOB,
          ProductType.EDGE_HANDLE
        ]),
        title: 'storageone.productListNoHandlesOptionTitle'
      }
    },
    {
      id: 'fronts-selected-menu-accessories',
      title: 'storageone.productListAccessoriesTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'designText, communicatedSizeText',
      productThumbToolTip: 'name, designText',
      behaviors: {
        productClicked: [addAccessory],
        productDropped: [addProduct]
      },
      hidden: (coreApi: CoreApi, selectedEntityId: number) =>
        isProductType(coreApi, selectedEntityId, ProductType.SMASTAD_DRAWER_ASM) ||
        isProductType(coreApi, selectedEntityId, ProductType.SMASTAD_BENCH_DRAWER),
      productTypes: [ProductType.SMASTAD_HOOK_CLIP, ProductType.SMASTAD_MIRROR],
      filters: [],
      productFilters: [],
      noneOption: {
        behaviors: { removeProducts: [removeAccessoriesForSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([
          ProductType.SMASTAD_HOOK_CLIP,
          ProductType.SMASTAD_MIRROR
        ]),
        title: 'storageone.productListNoExteriorAccessoriesOptionTitle'
      }
    }
  ]
};

export default selectedMenu;
